import React from "react";
import { Link } from "react-router-dom";

const Error = () => {
	return (
		<div className="flex flex-col items-center justify-center h-screen bg-black">
			<h1 className="text-6xl font-bold text-white">Oops! Page Not Found.</h1>
			<p className="text-gray-600 mt-5 ">
				<Link to="/" className="text-orange-500">
					Go to Homepage
				</Link>
			</p>
		</div>
	);
};

export default Error;
